<script>
export default {
  name: "OurServices",
  props:{
    services: Array
  },
  data(){
    return {
      scrollWrapper: false,
      isDown: false,
      startX: false,
      scrollLeft: false,
    }
  },
  mounted() {
    this.scrollWrapper = document.getElementById('services-card');

    this.scrollWrapper.addEventListener('mousedown', (e) => {
      this.isDown = true;
      this.scrollWrapper.style.cursor = 'grabbing';
      this.startX = e.pageX - this.scrollWrapper.offsetLeft;
      this.scrollLeft = this.scrollWrapper.scrollLeft;
    });

    this.scrollWrapper.addEventListener('mouseleave', () => {
      this.isDown = false;
      this.scrollWrapper.style.cursor = 'grab';
    });

    this.scrollWrapper.addEventListener('mouseup', () => {
      this.isDown = false;
      this.scrollWrapper.style.cursor = 'grab';
    });

    this.scrollWrapper.addEventListener('mousemove', (e) => {
      if(!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.scrollWrapper.offsetLeft;
      const walk = (x - this.startX) * 2; // Умножаем для более плавного скролла
      this.scrollWrapper.scrollLeft = this.scrollLeft - walk;
    });
    $(document).ready(function() {
      var leftMar = document.querySelector('.service-card#Управление').getBoundingClientRect().left
      $('.services-cards').scrollLeft(leftMar * 0.75); // Прокрутка на 300px вправо
    });
  }
}
</script>

<template>
  <div class="our-services left flex flex-column">
    <svg class="our-services-blue-arrow" width="191" height="156" viewBox="0 0 191 156" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.15415 129.956C4.94093 133.104 3.55747 151.159 4.15415 151.948M4.15415 151.948C4.6638 152.622 13.4287 146.602 22.1378 140.952M4.15415 151.948C17.9395 111.403 63.8004 110.884 98.0689 111.962C139.52 113.266 127.168 112.097 161.012 115.961C210.697 121.634 388.533 67.7134 222.955 4" stroke="#A6CFF2" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <h1 class="flex flex-x-center">Наши услуги</h1>
    <div class="services-cards left flex" id="services-card">
      <div class="service-card left flex flex-y-center flex-column" v-for="item in services" :id="item.tarif">
        <div class="img-service-container flex flex-xy-center left">
          <img :src="'/assets/' + item.img" alt="service-card">
          <div class="packet left">{{ item.tarif }}</div>
        </div>
        <div class="little-line right mobile" :class="item.color_line1"></div>
          <div class="big-line mobile" :class="item.color_line2"></div>
          <span>{{ item.desc }}</span>
          <router-link :to="{'path': item.route, query:{'hash' : 'lead-form', 'filter' : item.filter}}">
            <button>Узнать подробнее</button>
          </router-link>
        </div>
      <div class="service-card left flex">asdad</div>
    </div>
  </div>
</template>

<style scoped>

</style>